"use strict";

var _Object$keys2 = require("@babel/runtime-corejs2/core-js/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors");
var _Object$defineProperties = require("@babel/runtime-corejs2/core-js/object/define-properties");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ProductTabModel = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/toConsumableArray"));
require("core-js/modules/es6.array.map.js");
require("core-js/modules/es6.array.filter.js");
require("core-js/modules/es6.array.find.js");
require("core-js/modules/es6.object.to-string.js");
require("core-js/modules/es6.regexp.to-string.js");
require("core-js/modules/es6.function.name.js");
var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));
var _isArray = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/array/is-array"));
var _assign = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/assign"));
var _section = require("@nucleo/section");
var _filter = require("@nucleo/filter");
var _flatten = _interopRequireDefault(require("lodash/flatten"));
var _size = _interopRequireDefault(require("lodash/size"));
var _get = _interopRequireDefault(require("lodash/get"));
var _product = require("@nucleo/product");
var _catalog = require("@nucleo/catalog");
var _constants = require("./constants");
var _helper = require("./helper");
function cov_1da4qle0dk() {
  var path = "/codebuild/output/src1340795087/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/nucleo/productList/lib/model.js";
  var hash = "805b87d42f06df047fefc54637ec9d9b93293c74";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src1340795087/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/nucleo/productList/lib/model.js",
    statementMap: {
      "0": {
        start: {
          line: 11,
          column: 30
        },
        end: {
          line: 25,
          column: 1
        }
      },
      "1": {
        start: {
          line: 12,
          column: 28
        },
        end: {
          line: 12,
          column: 46
        }
      },
      "2": {
        start: {
          line: 13,
          column: 25
        },
        end: {
          line: 13,
          column: 103
        }
      },
      "3": {
        start: {
          line: 14,
          column: 2
        },
        end: {
          line: 24,
          column: 4
        }
      },
      "4": {
        start: {
          line: 27,
          column: 48
        },
        end: {
          line: 38,
          column: 1
        }
      },
      "5": {
        start: {
          line: 28,
          column: 38
        },
        end: {
          line: 28,
          column: 80
        }
      },
      "6": {
        start: {
          line: 29,
          column: 2
        },
        end: {
          line: 36,
          column: 4
        }
      },
      "7": {
        start: {
          line: 31,
          column: 6
        },
        end: {
          line: 33,
          column: 16
        }
      },
      "8": {
        start: {
          line: 40,
          column: 35
        },
        end: {
          line: 56,
          column: 1
        }
      },
      "9": {
        start: {
          line: 41,
          column: 2
        },
        end: {
          line: 43,
          column: 3
        }
      },
      "10": {
        start: {
          line: 42,
          column: 4
        },
        end: {
          line: 42,
          column: 14
        }
      },
      "11": {
        start: {
          line: 46,
          column: 2
        },
        end: {
          line: 48,
          column: 3
        }
      },
      "12": {
        start: {
          line: 47,
          column: 4
        },
        end: {
          line: 47,
          column: 71
        }
      },
      "13": {
        start: {
          line: 49,
          column: 2
        },
        end: {
          line: 51,
          column: 3
        }
      },
      "14": {
        start: {
          line: 50,
          column: 4
        },
        end: {
          line: 50,
          column: 63
        }
      },
      "15": {
        start: {
          line: 52,
          column: 2
        },
        end: {
          line: 54,
          column: 3
        }
      },
      "16": {
        start: {
          line: 53,
          column: 4
        },
        end: {
          line: 53,
          column: 14
        }
      },
      "17": {
        start: {
          line: 55,
          column: 2
        },
        end: {
          line: 55,
          column: 93
        }
      },
      "18": {
        start: {
          line: 58,
          column: 31
        },
        end: {
          line: 91,
          column: 1
        }
      },
      "19": {
        start: {
          line: 68,
          column: 27
        },
        end: {
          line: 70,
          column: 75
        }
      },
      "20": {
        start: {
          line: 72,
          column: 21
        },
        end: {
          line: 74,
          column: 82
        }
      },
      "21": {
        start: {
          line: 73,
          column: 32
        },
        end: {
          line: 73,
          column: 44
        }
      },
      "22": {
        start: {
          line: 76,
          column: 17
        },
        end: {
          line: 81,
          column: 7
        }
      },
      "23": {
        start: {
          line: 76,
          column: 42
        },
        end: {
          line: 81,
          column: 5
        }
      },
      "24": {
        start: {
          line: 84,
          column: 4
        },
        end: {
          line: 89,
          column: 13
        }
      },
      "25": {
        start: {
          line: 86,
          column: 10
        },
        end: {
          line: 87,
          column: 124
        }
      },
      "26": {
        start: {
          line: 87,
          column: 65
        },
        end: {
          line: 87,
          column: 123
        }
      },
      "27": {
        start: {
          line: 93,
          column: 25
        },
        end: {
          line: 395,
          column: 1
        }
      },
      "28": {
        start: {
          line: 103,
          column: 17
        },
        end: {
          line: 103,
          column: 121
        }
      },
      "29": {
        start: {
          line: 105,
          column: 4
        },
        end: {
          line: 178,
          column: 46
        }
      },
      "30": {
        start: {
          line: 107,
          column: 24
        },
        end: {
          line: 107,
          column: 32
        }
      },
      "31": {
        start: {
          line: 110,
          column: 8
        },
        end: {
          line: 166,
          column: 9
        }
      },
      "32": {
        start: {
          line: 111,
          column: 10
        },
        end: {
          line: 111,
          column: 47
        }
      },
      "33": {
        start: {
          line: 113,
          column: 10
        },
        end: {
          line: 165,
          column: 11
        }
      },
      "34": {
        start: {
          line: 115,
          column: 14
        },
        end: {
          line: 118,
          column: 18
        }
      },
      "35": {
        start: {
          line: 115,
          column: 79
        },
        end: {
          line: 118,
          column: 15
        }
      },
      "36": {
        start: {
          line: 119,
          column: 14
        },
        end: {
          line: 119,
          column: 20
        }
      },
      "37": {
        start: {
          line: 125,
          column: 14
        },
        end: {
          line: 125,
          column: 58
        }
      },
      "38": {
        start: {
          line: 126,
          column: 14
        },
        end: {
          line: 131,
          column: 15
        }
      },
      "39": {
        start: {
          line: 127,
          column: 16
        },
        end: {
          line: 130,
          column: 19
        }
      },
      "40": {
        start: {
          line: 132,
          column: 14
        },
        end: {
          line: 132,
          column: 20
        }
      },
      "41": {
        start: {
          line: 141,
          column: 14
        },
        end: {
          line: 146,
          column: 20
        }
      },
      "42": {
        start: {
          line: 142,
          column: 36
        },
        end: {
          line: 142,
          column: 95
        }
      },
      "43": {
        start: {
          line: 143,
          column: 34
        },
        end: {
          line: 146,
          column: 17
        }
      },
      "44": {
        start: {
          line: 147,
          column: 14
        },
        end: {
          line: 147,
          column: 20
        }
      },
      "45": {
        start: {
          line: 149,
          column: 14
        },
        end: {
          line: 154,
          column: 16
        }
      },
      "46": {
        start: {
          line: 157,
          column: 14
        },
        end: {
          line: 160,
          column: 16
        }
      },
      "47": {
        start: {
          line: 161,
          column: 14
        },
        end: {
          line: 161,
          column: 20
        }
      },
      "48": {
        start: {
          line: 163,
          column: 14
        },
        end: {
          line: 163,
          column: 31
        }
      },
      "49": {
        start: {
          line: 164,
          column: 14
        },
        end: {
          line: 164,
          column: 20
        }
      },
      "50": {
        start: {
          line: 167,
          column: 8
        },
        end: {
          line: 176,
          column: 10
        }
      },
      "51": {
        start: {
          line: 172,
          column: 45
        },
        end: {
          line: 175,
          column: 11
        }
      },
      "52": {
        start: {
          line: 178,
          column: 21
        },
        end: {
          line: 178,
          column: 44
        }
      },
      "53": {
        start: {
          line: 195,
          column: 4
        },
        end: {
          line: 221,
          column: 6
        }
      },
      "54": {
        start: {
          line: 196,
          column: 6
        },
        end: {
          line: 219,
          column: 7
        }
      },
      "55": {
        start: {
          line: 197,
          column: 8
        },
        end: {
          line: 218,
          column: 10
        }
      },
      "56": {
        start: {
          line: 200,
          column: 31
        },
        end: {
          line: 200,
          column: 57
        }
      },
      "57": {
        start: {
          line: 201,
          column: 12
        },
        end: {
          line: 215,
          column: 13
        }
      },
      "58": {
        start: {
          line: 203,
          column: 14
        },
        end: {
          line: 208,
          column: 15
        }
      },
      "59": {
        start: {
          line: 204,
          column: 16
        },
        end: {
          line: 207,
          column: 20
        }
      },
      "60": {
        start: {
          line: 204,
          column: 74
        },
        end: {
          line: 207,
          column: 17
        }
      },
      "61": {
        start: {
          line: 210,
          column: 16
        },
        end: {
          line: 212,
          column: 30
        }
      },
      "62": {
        start: {
          line: 214,
          column: 14
        },
        end: {
          line: 214,
          column: 65
        }
      },
      "63": {
        start: {
          line: 216,
          column: 12
        },
        end: {
          line: 216,
          column: 30
        }
      },
      "64": {
        start: {
          line: 220,
          column: 6
        },
        end: {
          line: 220,
          column: 17
        }
      },
      "65": {
        start: {
          line: 223,
          column: 26
        },
        end: {
          line: 223,
          column: 88
        }
      },
      "66": {
        start: {
          line: 229,
          column: 4
        },
        end: {
          line: 242,
          column: 6
        }
      },
      "67": {
        start: {
          line: 230,
          column: 6
        },
        end: {
          line: 232,
          column: 7
        }
      },
      "68": {
        start: {
          line: 231,
          column: 8
        },
        end: {
          line: 231,
          column: 19
        }
      },
      "69": {
        start: {
          line: 233,
          column: 6
        },
        end: {
          line: 241,
          column: 8
        }
      },
      "70": {
        start: {
          line: 236,
          column: 10
        },
        end: {
          line: 238,
          column: 11
        }
      },
      "71": {
        start: {
          line: 237,
          column: 12
        },
        end: {
          line: 237,
          column: 27
        }
      },
      "72": {
        start: {
          line: 239,
          column: 10
        },
        end: {
          line: 239,
          column: 93
        }
      },
      "73": {
        start: {
          line: 245,
          column: 21
        },
        end: {
          line: 245,
          column: 23
        }
      },
      "74": {
        start: {
          line: 246,
          column: 4
        },
        end: {
          line: 254,
          column: 7
        }
      },
      "75": {
        start: {
          line: 247,
          column: 6
        },
        end: {
          line: 249,
          column: 7
        }
      },
      "76": {
        start: {
          line: 248,
          column: 8
        },
        end: {
          line: 248,
          column: 15
        }
      },
      "77": {
        start: {
          line: 250,
          column: 6
        },
        end: {
          line: 253,
          column: 8
        }
      },
      "78": {
        start: {
          line: 251,
          column: 32
        },
        end: {
          line: 251,
          column: 68
        }
      },
      "79": {
        start: {
          line: 252,
          column: 8
        },
        end: {
          line: 252,
          column: 67
        }
      },
      "80": {
        start: {
          line: 252,
          column: 43
        },
        end: {
          line: 252,
          column: 65
        }
      },
      "81": {
        start: {
          line: 255,
          column: 4
        },
        end: {
          line: 255,
          column: 20
        }
      },
      "82": {
        start: {
          line: 262,
          column: 4
        },
        end: {
          line: 266,
          column: 5
        }
      },
      "83": {
        start: {
          line: 264,
          column: 23
        },
        end: {
          line: 264,
          column: 55
        }
      },
      "84": {
        start: {
          line: 265,
          column: 20
        },
        end: {
          line: 265,
          column: 64
        }
      },
      "85": {
        start: {
          line: 272,
          column: 8
        },
        end: {
          line: 272,
          column: 14
        }
      },
      "86": {
        start: {
          line: 273,
          column: 23
        },
        end: {
          line: 273,
          column: 61
        }
      },
      "87": {
        start: {
          line: 273,
          column: 40
        },
        end: {
          line: 273,
          column: 60
        }
      },
      "88": {
        start: {
          line: 275,
          column: 28
        },
        end: {
          line: 278,
          column: 5
        }
      },
      "89": {
        start: {
          line: 280,
          column: 4
        },
        end: {
          line: 282,
          column: 5
        }
      },
      "90": {
        start: {
          line: 281,
          column: 6
        },
        end: {
          line: 281,
          column: 18
        }
      },
      "91": {
        start: {
          line: 284,
          column: 27
        },
        end: {
          line: 284,
          column: 115
        }
      },
      "92": {
        start: {
          line: 284,
          column: 86
        },
        end: {
          line: 284,
          column: 114
        }
      },
      "93": {
        start: {
          line: 286,
          column: 4
        },
        end: {
          line: 288,
          column: 5
        }
      },
      "94": {
        start: {
          line: 287,
          column: 6
        },
        end: {
          line: 287,
          column: 18
        }
      },
      "95": {
        start: {
          line: 290,
          column: 4
        },
        end: {
          line: 292,
          column: 5
        }
      },
      "96": {
        start: {
          line: 291,
          column: 6
        },
        end: {
          line: 291,
          column: 18
        }
      },
      "97": {
        start: {
          line: 294,
          column: 29
        },
        end: {
          line: 294,
          column: 48
        }
      },
      "98": {
        start: {
          line: 295,
          column: 25
        },
        end: {
          line: 295,
          column: 32
        }
      },
      "99": {
        start: {
          line: 297,
          column: 4
        },
        end: {
          line: 386,
          column: 7
        }
      },
      "100": {
        start: {
          line: 298,
          column: 24
        },
        end: {
          line: 298,
          column: 31
        }
      },
      "101": {
        start: {
          line: 299,
          column: 6
        },
        end: {
          line: 301,
          column: 7
        }
      },
      "102": {
        start: {
          line: 300,
          column: 8
        },
        end: {
          line: 300,
          column: 20
        }
      },
      "103": {
        start: {
          line: 302,
          column: 21
        },
        end: {
          line: 302,
          column: 22
        }
      },
      "104": {
        start: {
          line: 303,
          column: 6
        },
        end: {
          line: 384,
          column: 9
        }
      },
      "105": {
        start: {
          line: 306,
          column: 34
        },
        end: {
          line: 306,
          column: 36
        }
      },
      "106": {
        start: {
          line: 307,
          column: 28
        },
        end: {
          line: 307,
          column: 32
        }
      },
      "107": {
        start: {
          line: 308,
          column: 31
        },
        end: {
          line: 308,
          column: 38
        }
      },
      "108": {
        start: {
          line: 312,
          column: 12
        },
        end: {
          line: 312,
          column: 27
        }
      },
      "109": {
        start: {
          line: 314,
          column: 41
        },
        end: {
          line: 314,
          column: 42
        }
      },
      "110": {
        start: {
          line: 315,
          column: 8
        },
        end: {
          line: 329,
          column: 9
        }
      },
      "111": {
        start: {
          line: 316,
          column: 10
        },
        end: {
          line: 328,
          column: 13
        }
      },
      "112": {
        start: {
          line: 317,
          column: 43
        },
        end: {
          line: 325,
          column: 13
        }
      },
      "113": {
        start: {
          line: 326,
          column: 12
        },
        end: {
          line: 326,
          column: 59
        }
      },
      "114": {
        start: {
          line: 327,
          column: 12
        },
        end: {
          line: 327,
          column: 63
        }
      },
      "115": {
        start: {
          line: 331,
          column: 8
        },
        end: {
          line: 345,
          column: 9
        }
      },
      "116": {
        start: {
          line: 333,
          column: 12
        },
        end: {
          line: 333,
          column: 70
        }
      },
      "117": {
        start: {
          line: 334,
          column: 12
        },
        end: {
          line: 334,
          column: 66
        }
      },
      "118": {
        start: {
          line: 335,
          column: 12
        },
        end: {
          line: 335,
          column: 25
        }
      },
      "119": {
        start: {
          line: 336,
          column: 12
        },
        end: {
          line: 336,
          column: 18
        }
      },
      "120": {
        start: {
          line: 338,
          column: 12
        },
        end: {
          line: 338,
          column: 56
        }
      },
      "121": {
        start: {
          line: 339,
          column: 12
        },
        end: {
          line: 339,
          column: 60
        }
      },
      "122": {
        start: {
          line: 341,
          column: 12
        },
        end: {
          line: 341,
          column: 25
        }
      },
      "123": {
        start: {
          line: 342,
          column: 12
        },
        end: {
          line: 342,
          column: 18
        }
      },
      "124": {
        start: {
          line: 344,
          column: 12
        },
        end: {
          line: 344,
          column: 18
        }
      },
      "125": {
        start: {
          line: 347,
          column: 31
        },
        end: {
          line: 349,
          column: 46
        }
      },
      "126": {
        start: {
          line: 347,
          column: 65
        },
        end: {
          line: 349,
          column: 45
        }
      },
      "127": {
        start: {
          line: 351,
          column: 8
        },
        end: {
          line: 354,
          column: 9
        }
      },
      "128": {
        start: {
          line: 352,
          column: 10
        },
        end: {
          line: 352,
          column: 24
        }
      },
      "129": {
        start: {
          line: 353,
          column: 10
        },
        end: {
          line: 353,
          column: 22
        }
      },
      "130": {
        start: {
          line: 356,
          column: 8
        },
        end: {
          line: 362,
          column: 9
        }
      },
      "131": {
        start: {
          line: 357,
          column: 10
        },
        end: {
          line: 357,
          column: 33
        }
      },
      "132": {
        start: {
          line: 358,
          column: 10
        },
        end: {
          line: 358,
          column: 32
        }
      },
      "133": {
        start: {
          line: 360,
          column: 10
        },
        end: {
          line: 360,
          column: 87
        }
      },
      "134": {
        start: {
          line: 361,
          column: 10
        },
        end: {
          line: 361,
          column: 37
        }
      },
      "135": {
        start: {
          line: 364,
          column: 28
        },
        end: {
          line: 364,
          column: 64
        }
      },
      "136": {
        start: {
          line: 366,
          column: 31
        },
        end: {
          line: 376,
          column: 9
        }
      },
      "137": {
        start: {
          line: 378,
          column: 8
        },
        end: {
          line: 378,
          column: 49
        }
      },
      "138": {
        start: {
          line: 379,
          column: 8
        },
        end: {
          line: 379,
          column: 22
        }
      },
      "139": {
        start: {
          line: 381,
          column: 8
        },
        end: {
          line: 381,
          column: 50
        }
      },
      "140": {
        start: {
          line: 382,
          column: 8
        },
        end: {
          line: 382,
          column: 60
        }
      },
      "141": {
        start: {
          line: 383,
          column: 8
        },
        end: {
          line: 383,
          column: 20
        }
      },
      "142": {
        start: {
          line: 385,
          column: 6
        },
        end: {
          line: 385,
          column: 17
        }
      },
      "143": {
        start: {
          line: 388,
          column: 4
        },
        end: {
          line: 388,
          column: 27
        }
      },
      "144": {
        start: {
          line: 391,
          column: 55
        },
        end: {
          line: 394,
          column: 5
        }
      },
      "145": {
        start: {
          line: 391,
          column: 72
        },
        end: {
          line: 394,
          column: 3
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 11,
            column: 30
          },
          end: {
            line: 11,
            column: 31
          }
        },
        loc: {
          start: {
            line: 11,
            column: 80
          },
          end: {
            line: 25,
            column: 1
          }
        },
        line: 11
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 27,
            column: 48
          },
          end: {
            line: 27,
            column: 49
          }
        },
        loc: {
          start: {
            line: 27,
            column: 82
          },
          end: {
            line: 38,
            column: 1
          }
        },
        line: 27
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 30,
            column: 4
          },
          end: {
            line: 30,
            column: 5
          }
        },
        loc: {
          start: {
            line: 31,
            column: 6
          },
          end: {
            line: 33,
            column: 16
          }
        },
        line: 31
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 40,
            column: 35
          },
          end: {
            line: 40,
            column: 36
          }
        },
        loc: {
          start: {
            line: 40,
            column: 61
          },
          end: {
            line: 56,
            column: 1
          }
        },
        line: 40
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 59,
            column: 7
          },
          end: {
            line: 59,
            column: 8
          }
        },
        loc: {
          start: {
            line: 59,
            column: 83
          },
          end: {
            line: 90,
            column: 3
          }
        },
        line: 59
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 73,
            column: 21
          },
          end: {
            line: 73,
            column: 22
          }
        },
        loc: {
          start: {
            line: 73,
            column: 32
          },
          end: {
            line: 73,
            column: 44
          }
        },
        line: 73
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 76,
            column: 30
          },
          end: {
            line: 76,
            column: 31
          }
        },
        loc: {
          start: {
            line: 76,
            column: 42
          },
          end: {
            line: 81,
            column: 5
          }
        },
        line: 76
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 85,
            column: 20
          },
          end: {
            line: 85,
            column: 21
          }
        },
        loc: {
          start: {
            line: 86,
            column: 10
          },
          end: {
            line: 87,
            column: 124
          }
        },
        line: 86
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 87,
            column: 53
          },
          end: {
            line: 87,
            column: 54
          }
        },
        loc: {
          start: {
            line: 87,
            column: 65
          },
          end: {
            line: 87,
            column: 123
          }
        },
        line: 87
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 101,
            column: 18
          },
          end: {
            line: 101,
            column: 19
          }
        },
        loc: {
          start: {
            line: 101,
            column: 77
          },
          end: {
            line: 179,
            column: 3
          }
        },
        line: 101
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 105,
            column: 20
          },
          end: {
            line: 105,
            column: 21
          }
        },
        loc: {
          start: {
            line: 105,
            column: 27
          },
          end: {
            line: 177,
            column: 7
          }
        },
        line: 105
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 115,
            column: 67
          },
          end: {
            line: 115,
            column: 68
          }
        },
        loc: {
          start: {
            line: 115,
            column: 79
          },
          end: {
            line: 118,
            column: 15
          }
        },
        line: 115
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 142,
            column: 24
          },
          end: {
            line: 142,
            column: 25
          }
        },
        loc: {
          start: {
            line: 142,
            column: 36
          },
          end: {
            line: 142,
            column: 95
          }
        },
        line: 142
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 143,
            column: 21
          },
          end: {
            line: 143,
            column: 22
          }
        },
        loc: {
          start: {
            line: 143,
            column: 34
          },
          end: {
            line: 146,
            column: 17
          }
        },
        line: 143
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 172,
            column: 36
          },
          end: {
            line: 172,
            column: 37
          }
        },
        loc: {
          start: {
            line: 172,
            column: 45
          },
          end: {
            line: 175,
            column: 11
          }
        },
        line: 172
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 178,
            column: 14
          },
          end: {
            line: 178,
            column: 15
          }
        },
        loc: {
          start: {
            line: 178,
            column: 21
          },
          end: {
            line: 178,
            column: 44
          }
        },
        line: 178
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 184,
            column: 27
          },
          end: {
            line: 184,
            column: 28
          }
        },
        loc: {
          start: {
            line: 195,
            column: 4
          },
          end: {
            line: 221,
            column: 6
          }
        },
        line: 195
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 195,
            column: 13
          },
          end: {
            line: 195,
            column: 14
          }
        },
        loc: {
          start: {
            line: 195,
            column: 20
          },
          end: {
            line: 221,
            column: 5
          }
        },
        line: 195
      },
      "18": {
        name: "(anonymous_18)",
        decl: {
          start: {
            line: 199,
            column: 37
          },
          end: {
            line: 199,
            column: 38
          }
        },
        loc: {
          start: {
            line: 199,
            column: 48
          },
          end: {
            line: 217,
            column: 11
          }
        },
        line: 199
      },
      "19": {
        name: "(anonymous_19)",
        decl: {
          start: {
            line: 204,
            column: 62
          },
          end: {
            line: 204,
            column: 63
          }
        },
        loc: {
          start: {
            line: 204,
            column: 74
          },
          end: {
            line: 207,
            column: 17
          }
        },
        line: 204
      },
      "20": {
        name: "(anonymous_20)",
        decl: {
          start: {
            line: 223,
            column: 11
          },
          end: {
            line: 223,
            column: 12
          }
        },
        loc: {
          start: {
            line: 223,
            column: 26
          },
          end: {
            line: 223,
            column: 88
          }
        },
        line: 223
      },
      "21": {
        name: "(anonymous_21)",
        decl: {
          start: {
            line: 228,
            column: 26
          },
          end: {
            line: 228,
            column: 27
          }
        },
        loc: {
          start: {
            line: 229,
            column: 4
          },
          end: {
            line: 242,
            column: 6
          }
        },
        line: 229
      },
      "22": {
        name: "(anonymous_22)",
        decl: {
          start: {
            line: 229,
            column: 13
          },
          end: {
            line: 229,
            column: 14
          }
        },
        loc: {
          start: {
            line: 229,
            column: 20
          },
          end: {
            line: 242,
            column: 5
          }
        },
        line: 229
      },
      "23": {
        name: "(anonymous_23)",
        decl: {
          start: {
            line: 235,
            column: 35
          },
          end: {
            line: 235,
            column: 36
          }
        },
        loc: {
          start: {
            line: 235,
            column: 46
          },
          end: {
            line: 240,
            column: 9
          }
        },
        line: 235
      },
      "24": {
        name: "(anonymous_24)",
        decl: {
          start: {
            line: 244,
            column: 23
          },
          end: {
            line: 244,
            column: 24
          }
        },
        loc: {
          start: {
            line: 244,
            column: 42
          },
          end: {
            line: 256,
            column: 3
          }
        },
        line: 244
      },
      "25": {
        name: "(anonymous_25)",
        decl: {
          start: {
            line: 246,
            column: 17
          },
          end: {
            line: 246,
            column: 18
          }
        },
        loc: {
          start: {
            line: 246,
            column: 24
          },
          end: {
            line: 254,
            column: 5
          }
        },
        line: 246
      },
      "26": {
        name: "(anonymous_26)",
        decl: {
          start: {
            line: 250,
            column: 27
          },
          end: {
            line: 250,
            column: 28
          }
        },
        loc: {
          start: {
            line: 250,
            column: 38
          },
          end: {
            line: 253,
            column: 7
          }
        },
        line: 250
      },
      "27": {
        name: "(anonymous_27)",
        decl: {
          start: {
            line: 252,
            column: 32
          },
          end: {
            line: 252,
            column: 33
          }
        },
        loc: {
          start: {
            line: 252,
            column: 43
          },
          end: {
            line: 252,
            column: 65
          }
        },
        line: 252
      },
      "28": {
        name: "(anonymous_28)",
        decl: {
          start: {
            line: 261,
            column: 26
          },
          end: {
            line: 261,
            column: 27
          }
        },
        loc: {
          start: {
            line: 262,
            column: 4
          },
          end: {
            line: 266,
            column: 5
          }
        },
        line: 262
      },
      "29": {
        name: "(anonymous_29)",
        decl: {
          start: {
            line: 264,
            column: 16
          },
          end: {
            line: 264,
            column: 17
          }
        },
        loc: {
          start: {
            line: 264,
            column: 23
          },
          end: {
            line: 264,
            column: 55
          }
        },
        line: 264
      },
      "30": {
        name: "(anonymous_30)",
        decl: {
          start: {
            line: 265,
            column: 13
          },
          end: {
            line: 265,
            column: 14
          }
        },
        loc: {
          start: {
            line: 265,
            column: 20
          },
          end: {
            line: 265,
            column: 64
          }
        },
        line: 265
      },
      "31": {
        name: "(anonymous_31)",
        decl: {
          start: {
            line: 268,
            column: 25
          },
          end: {
            line: 268,
            column: 26
          }
        },
        loc: {
          start: {
            line: 268,
            column: 79
          },
          end: {
            line: 389,
            column: 3
          }
        },
        line: 268
      },
      "32": {
        name: "(anonymous_32)",
        decl: {
          start: {
            line: 273,
            column: 33
          },
          end: {
            line: 273,
            column: 34
          }
        },
        loc: {
          start: {
            line: 273,
            column: 40
          },
          end: {
            line: 273,
            column: 60
          }
        },
        line: 273
      },
      "33": {
        name: "(anonymous_33)",
        decl: {
          start: {
            line: 284,
            column: 75
          },
          end: {
            line: 284,
            column: 76
          }
        },
        loc: {
          start: {
            line: 284,
            column: 86
          },
          end: {
            line: 284,
            column: 114
          }
        },
        line: 284
      },
      "34": {
        name: "(anonymous_34)",
        decl: {
          start: {
            line: 297,
            column: 36
          },
          end: {
            line: 297,
            column: 37
          }
        },
        loc: {
          start: {
            line: 297,
            column: 47
          },
          end: {
            line: 386,
            column: 5
          }
        },
        line: 297
      },
      "35": {
        name: "(anonymous_35)",
        decl: {
          start: {
            line: 303,
            column: 20
          },
          end: {
            line: 303,
            column: 21
          }
        },
        loc: {
          start: {
            line: 303,
            column: 28
          },
          end: {
            line: 384,
            column: 7
          }
        },
        line: 303
      },
      "36": {
        name: "(anonymous_36)",
        decl: {
          start: {
            line: 316,
            column: 29
          },
          end: {
            line: 316,
            column: 30
          }
        },
        loc: {
          start: {
            line: 316,
            column: 42
          },
          end: {
            line: 328,
            column: 11
          }
        },
        line: 316
      },
      "37": {
        name: "(anonymous_37)",
        decl: {
          start: {
            line: 347,
            column: 56
          },
          end: {
            line: 347,
            column: 57
          }
        },
        loc: {
          start: {
            line: 347,
            column: 65
          },
          end: {
            line: 349,
            column: 45
          }
        },
        line: 347
      },
      "38": {
        name: "(anonymous_38)",
        decl: {
          start: {
            line: 391,
            column: 18
          },
          end: {
            line: 391,
            column: 19
          }
        },
        loc: {
          start: {
            line: 391,
            column: 55
          },
          end: {
            line: 394,
            column: 5
          }
        },
        line: 391
      },
      "39": {
        name: "(anonymous_39)",
        decl: {
          start: {
            line: 391,
            column: 64
          },
          end: {
            line: 391,
            column: 65
          }
        },
        loc: {
          start: {
            line: 391,
            column: 72
          },
          end: {
            line: 394,
            column: 3
          }
        },
        line: 391
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 31,
            column: 6
          },
          end: {
            line: 33,
            column: 16
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 32,
            column: 10
          },
          end: {
            line: 32,
            column: 75
          }
        }, {
          start: {
            line: 33,
            column: 10
          },
          end: {
            line: 33,
            column: 16
          }
        }],
        line: 31
      },
      "1": {
        loc: {
          start: {
            line: 41,
            column: 2
          },
          end: {
            line: 43,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 41,
            column: 2
          },
          end: {
            line: 43,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 41
      },
      "2": {
        loc: {
          start: {
            line: 41,
            column: 6
          },
          end: {
            line: 41,
            column: 77
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 41,
            column: 6
          },
          end: {
            line: 41,
            column: 18
          }
        }, {
          start: {
            line: 41,
            column: 22
          },
          end: {
            line: 41,
            column: 65
          }
        }, {
          start: {
            line: 41,
            column: 69
          },
          end: {
            line: 41,
            column: 77
          }
        }],
        line: 41
      },
      "3": {
        loc: {
          start: {
            line: 46,
            column: 2
          },
          end: {
            line: 48,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 46,
            column: 2
          },
          end: {
            line: 48,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 46
      },
      "4": {
        loc: {
          start: {
            line: 47,
            column: 11
          },
          end: {
            line: 47,
            column: 70
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 47,
            column: 11
          },
          end: {
            line: 47,
            column: 64
          }
        }, {
          start: {
            line: 47,
            column: 68
          },
          end: {
            line: 47,
            column: 70
          }
        }],
        line: 47
      },
      "5": {
        loc: {
          start: {
            line: 49,
            column: 2
          },
          end: {
            line: 51,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 49,
            column: 2
          },
          end: {
            line: 51,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 49
      },
      "6": {
        loc: {
          start: {
            line: 52,
            column: 2
          },
          end: {
            line: 54,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 52,
            column: 2
          },
          end: {
            line: 54,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 52
      },
      "7": {
        loc: {
          start: {
            line: 68,
            column: 27
          },
          end: {
            line: 70,
            column: 75
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 69,
            column: 8
          },
          end: {
            line: 69,
            column: 84
          }
        }, {
          start: {
            line: 70,
            column: 8
          },
          end: {
            line: 70,
            column: 75
          }
        }],
        line: 68
      },
      "8": {
        loc: {
          start: {
            line: 72,
            column: 21
          },
          end: {
            line: 74,
            column: 82
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 73,
            column: 8
          },
          end: {
            line: 73,
            column: 45
          }
        }, {
          start: {
            line: 74,
            column: 8
          },
          end: {
            line: 74,
            column: 82
          }
        }],
        line: 72
      },
      "9": {
        loc: {
          start: {
            line: 74,
            column: 8
          },
          end: {
            line: 74,
            column: 82
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 74,
            column: 56
          },
          end: {
            line: 74,
            column: 64
          }
        }, {
          start: {
            line: 74,
            column: 67
          },
          end: {
            line: 74,
            column: 82
          }
        }],
        line: 74
      },
      "10": {
        loc: {
          start: {
            line: 74,
            column: 8
          },
          end: {
            line: 74,
            column: 53
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 74,
            column: 8
          },
          end: {
            line: 74,
            column: 31
          }
        }, {
          start: {
            line: 74,
            column: 35
          },
          end: {
            line: 74,
            column: 53
          }
        }],
        line: 74
      },
      "11": {
        loc: {
          start: {
            line: 84,
            column: 11
          },
          end: {
            line: 89,
            column: 12
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 85,
            column: 8
          },
          end: {
            line: 88,
            column: 9
          }
        }, {
          start: {
            line: 89,
            column: 8
          },
          end: {
            line: 89,
            column: 12
          }
        }],
        line: 84
      },
      "12": {
        loc: {
          start: {
            line: 86,
            column: 10
          },
          end: {
            line: 87,
            column: 124
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 86,
            column: 10
          },
          end: {
            line: 86,
            column: 48
          }
        }, {
          start: {
            line: 87,
            column: 10
          },
          end: {
            line: 87,
            column: 124
          }
        }],
        line: 86
      },
      "13": {
        loc: {
          start: {
            line: 87,
            column: 66
          },
          end: {
            line: 87,
            column: 99
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 87,
            column: 66
          },
          end: {
            line: 87,
            column: 93
          }
        }, {
          start: {
            line: 87,
            column: 97
          },
          end: {
            line: 87,
            column: 99
          }
        }],
        line: 87
      },
      "14": {
        loc: {
          start: {
            line: 110,
            column: 8
          },
          end: {
            line: 166,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 110,
            column: 8
          },
          end: {
            line: 166,
            column: 9
          }
        }, {
          start: {
            line: 112,
            column: 15
          },
          end: {
            line: 166,
            column: 9
          }
        }],
        line: 110
      },
      "15": {
        loc: {
          start: {
            line: 113,
            column: 10
          },
          end: {
            line: 165,
            column: 11
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 114,
            column: 12
          },
          end: {
            line: 119,
            column: 20
          }
        }, {
          start: {
            line: 124,
            column: 12
          },
          end: {
            line: 132,
            column: 20
          }
        }, {
          start: {
            line: 134,
            column: 12
          },
          end: {
            line: 134,
            column: 38
          }
        }, {
          start: {
            line: 135,
            column: 12
          },
          end: {
            line: 135,
            column: 38
          }
        }, {
          start: {
            line: 136,
            column: 12
          },
          end: {
            line: 136,
            column: 47
          }
        }, {
          start: {
            line: 137,
            column: 12
          },
          end: {
            line: 137,
            column: 47
          }
        }, {
          start: {
            line: 138,
            column: 12
          },
          end: {
            line: 138,
            column: 44
          }
        }, {
          start: {
            line: 139,
            column: 12
          },
          end: {
            line: 147,
            column: 20
          }
        }, {
          start: {
            line: 148,
            column: 12
          },
          end: {
            line: 161,
            column: 20
          }
        }, {
          start: {
            line: 162,
            column: 12
          },
          end: {
            line: 164,
            column: 20
          }
        }],
        line: 113
      },
      "16": {
        loc: {
          start: {
            line: 126,
            column: 14
          },
          end: {
            line: 131,
            column: 15
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 126,
            column: 14
          },
          end: {
            line: 131,
            column: 15
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 126
      },
      "17": {
        loc: {
          start: {
            line: 196,
            column: 6
          },
          end: {
            line: 219,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 196,
            column: 6
          },
          end: {
            line: 219,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 196
      },
      "18": {
        loc: {
          start: {
            line: 201,
            column: 12
          },
          end: {
            line: 215,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 201,
            column: 12
          },
          end: {
            line: 215,
            column: 13
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 201
      },
      "19": {
        loc: {
          start: {
            line: 203,
            column: 14
          },
          end: {
            line: 208,
            column: 15
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 203,
            column: 14
          },
          end: {
            line: 208,
            column: 15
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 203
      },
      "20": {
        loc: {
          start: {
            line: 210,
            column: 16
          },
          end: {
            line: 212,
            column: 30
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 211,
            column: 20
          },
          end: {
            line: 211,
            column: 101
          }
        }, {
          start: {
            line: 212,
            column: 20
          },
          end: {
            line: 212,
            column: 30
          }
        }],
        line: 210
      },
      "21": {
        loc: {
          start: {
            line: 210,
            column: 16
          },
          end: {
            line: 210,
            column: 60
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 210,
            column: 16
          },
          end: {
            line: 210,
            column: 37
          }
        }, {
          start: {
            line: 210,
            column: 41
          },
          end: {
            line: 210,
            column: 60
          }
        }],
        line: 210
      },
      "22": {
        loc: {
          start: {
            line: 223,
            column: 26
          },
          end: {
            line: 223,
            column: 88
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 223,
            column: 26
          },
          end: {
            line: 223,
            column: 57
          }
        }, {
          start: {
            line: 223,
            column: 61
          },
          end: {
            line: 223,
            column: 88
          }
        }],
        line: 223
      },
      "23": {
        loc: {
          start: {
            line: 230,
            column: 6
          },
          end: {
            line: 232,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 230,
            column: 6
          },
          end: {
            line: 232,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 230
      },
      "24": {
        loc: {
          start: {
            line: 236,
            column: 10
          },
          end: {
            line: 238,
            column: 11
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 236,
            column: 10
          },
          end: {
            line: 238,
            column: 11
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 236
      },
      "25": {
        loc: {
          start: {
            line: 247,
            column: 6
          },
          end: {
            line: 249,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 247,
            column: 6
          },
          end: {
            line: 249,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 247
      },
      "26": {
        loc: {
          start: {
            line: 247,
            column: 10
          },
          end: {
            line: 247,
            column: 41
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 247,
            column: 10
          },
          end: {
            line: 247,
            column: 17
          }
        }, {
          start: {
            line: 247,
            column: 21
          },
          end: {
            line: 247,
            column: 41
          }
        }],
        line: 247
      },
      "27": {
        loc: {
          start: {
            line: 264,
            column: 23
          },
          end: {
            line: 264,
            column: 55
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 264,
            column: 23
          },
          end: {
            line: 264,
            column: 31
          }
        }, {
          start: {
            line: 264,
            column: 35
          },
          end: {
            line: 264,
            column: 55
          }
        }],
        line: 264
      },
      "28": {
        loc: {
          start: {
            line: 280,
            column: 4
          },
          end: {
            line: 282,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 280,
            column: 4
          },
          end: {
            line: 282,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 280
      },
      "29": {
        loc: {
          start: {
            line: 284,
            column: 27
          },
          end: {
            line: 284,
            column: 115
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 284,
            column: 27
          },
          end: {
            line: 284,
            column: 46
          }
        }, {
          start: {
            line: 284,
            column: 50
          },
          end: {
            line: 284,
            column: 115
          }
        }],
        line: 284
      },
      "30": {
        loc: {
          start: {
            line: 286,
            column: 4
          },
          end: {
            line: 288,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 286,
            column: 4
          },
          end: {
            line: 288,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 286
      },
      "31": {
        loc: {
          start: {
            line: 290,
            column: 4
          },
          end: {
            line: 292,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 290,
            column: 4
          },
          end: {
            line: 292,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 290
      },
      "32": {
        loc: {
          start: {
            line: 299,
            column: 6
          },
          end: {
            line: 301,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 299,
            column: 6
          },
          end: {
            line: 301,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 299
      },
      "33": {
        loc: {
          start: {
            line: 315,
            column: 8
          },
          end: {
            line: 329,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 315,
            column: 8
          },
          end: {
            line: 329,
            column: 9
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 315
      },
      "34": {
        loc: {
          start: {
            line: 318,
            column: 18
          },
          end: {
            line: 318,
            column: 57
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 318,
            column: 18
          },
          end: {
            line: 318,
            column: 30
          }
        }, {
          start: {
            line: 318,
            column: 34
          },
          end: {
            line: 318,
            column: 57
          }
        }],
        line: 318
      },
      "35": {
        loc: {
          start: {
            line: 320,
            column: 24
          },
          end: {
            line: 320,
            column: 51
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 320,
            column: 24
          },
          end: {
            line: 320,
            column: 45
          }
        }, {
          start: {
            line: 320,
            column: 49
          },
          end: {
            line: 320,
            column: 51
          }
        }],
        line: 320
      },
      "36": {
        loc: {
          start: {
            line: 331,
            column: 8
          },
          end: {
            line: 345,
            column: 9
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 332,
            column: 10
          },
          end: {
            line: 336,
            column: 18
          }
        }, {
          start: {
            line: 337,
            column: 10
          },
          end: {
            line: 342,
            column: 18
          }
        }, {
          start: {
            line: 343,
            column: 10
          },
          end: {
            line: 344,
            column: 18
          }
        }],
        line: 331
      },
      "37": {
        loc: {
          start: {
            line: 347,
            column: 65
          },
          end: {
            line: 349,
            column: 45
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 347,
            column: 65
          },
          end: {
            line: 347,
            column: 88
          }
        }, {
          start: {
            line: 348,
            column: 13
          },
          end: {
            line: 348,
            column: 53
          }
        }, {
          start: {
            line: 349,
            column: 13
          },
          end: {
            line: 349,
            column: 45
          }
        }],
        line: 347
      },
      "38": {
        loc: {
          start: {
            line: 351,
            column: 8
          },
          end: {
            line: 354,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 351,
            column: 8
          },
          end: {
            line: 354,
            column: 9
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 351
      },
      "39": {
        loc: {
          start: {
            line: 356,
            column: 8
          },
          end: {
            line: 362,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 356,
            column: 8
          },
          end: {
            line: 362,
            column: 9
          }
        }, {
          start: {
            line: 359,
            column: 15
          },
          end: {
            line: 362,
            column: 9
          }
        }],
        line: 356
      },
      "40": {
        loc: {
          start: {
            line: 367,
            column: 14
          },
          end: {
            line: 367,
            column: 49
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 367,
            column: 14
          },
          end: {
            line: 367,
            column: 24
          }
        }, {
          start: {
            line: 367,
            column: 28
          },
          end: {
            line: 367,
            column: 49
          }
        }],
        line: 367
      },
      "41": {
        loc: {
          start: {
            line: 369,
            column: 17
          },
          end: {
            line: 369,
            column: 28
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 369,
            column: 17
          },
          end: {
            line: 369,
            column: 22
          }
        }, {
          start: {
            line: 369,
            column: 26
          },
          end: {
            line: 369,
            column: 28
          }
        }],
        line: 369
      },
      "42": {
        loc: {
          start: {
            line: 372,
            column: 16
          },
          end: {
            line: 372,
            column: 26
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 372,
            column: 16
          },
          end: {
            line: 372,
            column: 20
          }
        }, {
          start: {
            line: 372,
            column: 24
          },
          end: {
            line: 372,
            column: 26
          }
        }],
        line: 372
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0,
      "84": 0,
      "85": 0,
      "86": 0,
      "87": 0,
      "88": 0,
      "89": 0,
      "90": 0,
      "91": 0,
      "92": 0,
      "93": 0,
      "94": 0,
      "95": 0,
      "96": 0,
      "97": 0,
      "98": 0,
      "99": 0,
      "100": 0,
      "101": 0,
      "102": 0,
      "103": 0,
      "104": 0,
      "105": 0,
      "106": 0,
      "107": 0,
      "108": 0,
      "109": 0,
      "110": 0,
      "111": 0,
      "112": 0,
      "113": 0,
      "114": 0,
      "115": 0,
      "116": 0,
      "117": 0,
      "118": 0,
      "119": 0,
      "120": 0,
      "121": 0,
      "122": 0,
      "123": 0,
      "124": 0,
      "125": 0,
      "126": 0,
      "127": 0,
      "128": 0,
      "129": 0,
      "130": 0,
      "131": 0,
      "132": 0,
      "133": 0,
      "134": 0,
      "135": 0,
      "136": 0,
      "137": 0,
      "138": 0,
      "139": 0,
      "140": 0,
      "141": 0,
      "142": 0,
      "143": 0,
      "144": 0,
      "145": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0],
      "27": [0, 0],
      "28": [0, 0],
      "29": [0, 0],
      "30": [0, 0],
      "31": [0, 0],
      "32": [0, 0],
      "33": [0, 0],
      "34": [0, 0],
      "35": [0, 0],
      "36": [0, 0, 0],
      "37": [0, 0, 0],
      "38": [0, 0],
      "39": [0, 0],
      "40": [0, 0],
      "41": [0, 0],
      "42": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "805b87d42f06df047fefc54637ec9d9b93293c74"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1da4qle0dk = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1da4qle0dk();
function ownKeys(e, r) { var t = _Object$keys2(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
cov_1da4qle0dk().s[0]++;
var getDefaultFilterByTab = function getDefaultFilterByTab(priceFilterEnabled, productTypeFilterEnabled) {
  cov_1da4qle0dk().f[0]++;
  var defaultInitFilter = (cov_1da4qle0dk().s[1]++, [_filter.FilterField.DATE]);
  var defaultFilters = (cov_1da4qle0dk().s[2]++, (0, _helper.getArrFilters)(defaultInitFilter, priceFilterEnabled, productTypeFilterEnabled));
  cov_1da4qle0dk().s[3]++;
  return {
    OFFERS: [],
    SEASON_TICKETS: [],
    GOODS: [],
    VISIT: defaultFilters,
    EVENTS: defaultFilters,
    OTHER_PRODUCTS: defaultFilters,
    HOSPITALITY: defaultFilters,
    HOSPITALITY_BUNDLE: defaultFilters,
    TOURS: defaultFilters
  };
};
cov_1da4qle0dk().s[4]++;
var getCustomProductTypeForOtherProductsTab = function getCustomProductTypeForOtherProductsTab(customProductTypeByProductType) {
  cov_1da4qle0dk().f[1]++;
  var productTypesForOtherProduct = (cov_1da4qle0dk().s[5]++, _constants.ProductTypeByProductTabEnum.OTHER_PRODUCTS);
  cov_1da4qle0dk().s[6]++;
  return (0, _keys.default)(customProductTypeByProductType).reduce(function (result, currentProductType) {
    cov_1da4qle0dk().f[2]++;
    cov_1da4qle0dk().s[7]++;
    return productTypesForOtherProduct.indexOf(currentProductType) !== -1 ? (cov_1da4qle0dk().b[0][0]++, result.concat(customProductTypeByProductType[currentProductType])) : (cov_1da4qle0dk().b[0][1]++, result);
  }, []);
};
cov_1da4qle0dk().s[8]++;
var getCustomProductTypeForTab = function getCustomProductTypeForTab(catalogData, tabCode) {
  cov_1da4qle0dk().f[3]++;
  cov_1da4qle0dk().s[9]++;
  if ((cov_1da4qle0dk().b[2][0]++, !catalogData) || (cov_1da4qle0dk().b[2][1]++, !catalogData.customProductTypeByProductType) || (cov_1da4qle0dk().b[2][2]++, !tabCode)) {
    cov_1da4qle0dk().b[1][0]++;
    cov_1da4qle0dk().s[10]++;
    return [];
  } else {
    cov_1da4qle0dk().b[1][1]++;
  }
  // We use tabCode VISIT but ProducType return from RestAPI is VISIT_PASS
  // So we did a special case here to get custom type data from VISIT tab
  cov_1da4qle0dk().s[11]++;
  if (tabCode === _constants.ProductTabEnum.VISIT) {
    cov_1da4qle0dk().b[3][0]++;
    cov_1da4qle0dk().s[12]++;
    return (cov_1da4qle0dk().b[4][0]++, catalogData.customProductTypeByProductType.VISIT_PASS) || (cov_1da4qle0dk().b[4][1]++, []);
  } else {
    cov_1da4qle0dk().b[3][1]++;
  }
  cov_1da4qle0dk().s[13]++;
  if (catalogData.customProductTypeByProductType[tabCode]) {
    cov_1da4qle0dk().b[5][0]++;
    cov_1da4qle0dk().s[14]++;
    return catalogData.customProductTypeByProductType[tabCode];
  } else {
    cov_1da4qle0dk().b[5][1]++;
  }
  cov_1da4qle0dk().s[15]++;
  if (tabCode !== _constants.ProductTabEnum.OTHER_PRODUCTS) {
    cov_1da4qle0dk().b[6][0]++;
    cov_1da4qle0dk().s[16]++;
    return [];
  } else {
    cov_1da4qle0dk().b[6][1]++;
  }
  cov_1da4qle0dk().s[17]++;
  return getCustomProductTypeForOtherProductsTab(catalogData.customProductTypeByProductType);
};
var ProductTabModel = exports.ProductTabModel = (cov_1da4qle0dk().s[18]++, {
  get: function get(tabDatas, catalogSummary, priceFilterEnabled, productTypeFilterEnabled) {
    cov_1da4qle0dk().f[4]++;
    /*
    TabDatas can have 3 formats !!!!
    // 1. Array contain objects with code and arrFilters
    // => tabDatas = [{code: 'EVENTS', arrFilters: ['date', 'price']}]
    // 2. Array of codes => tabDatas = ['EVENTS', 'VISIT', 'OTHER_PRODUCTS']
    // 3. Empty array => tabDatas = [] => Use default tab codes
    */
    // If tabDatas has arrFilters => tabDatas was configure from POS => use it instead of default data
    var arrFilterByTab = (cov_1da4qle0dk().s[19]++, (0, _helper.isHasArrFilters)(tabDatas) ? (cov_1da4qle0dk().b[7][0]++, (0, _helper.getConfigFilterByTab)(tabDatas, priceFilterEnabled, productTypeFilterEnabled)) : (cov_1da4qle0dk().b[7][1]++, getDefaultFilterByTab(priceFilterEnabled, productTypeFilterEnabled)));
    // eslint-disable-next-line no-nested-ternary
    var tabCodes = (cov_1da4qle0dk().s[20]++, (0, _helper.isHasArrFilters)(tabDatas) ? (cov_1da4qle0dk().b[8][0]++, tabDatas.map(function (tabData) {
      cov_1da4qle0dk().f[5]++;
      cov_1da4qle0dk().s[21]++;
      return tabData.code;
    })) : (cov_1da4qle0dk().b[8][1]++, (cov_1da4qle0dk().b[10][0]++, (0, _isArray.default)(tabDatas)) && (cov_1da4qle0dk().b[10][1]++, (0, _size.default)(tabDatas) > 0) ? (cov_1da4qle0dk().b[9][0]++, tabDatas) : (cov_1da4qle0dk().b[9][1]++, _constants.DefaultTabCodes)));
    var tabs = (cov_1da4qle0dk().s[22]++, tabCodes.map(function (tabCode) {
      cov_1da4qle0dk().f[6]++;
      cov_1da4qle0dk().s[23]++;
      return {
        code: tabCode,
        sections: [],
        arrFilters: arrFilterByTab[tabCode],
        productTypes: getCustomProductTypeForTab(catalogSummary, tabCode)
      };
    }));
    // Filter available tabs depend on catalog summary product type return
    // On server side already check if to return product type which only have products
    cov_1da4qle0dk().s[24]++;
    return catalogSummary ? (cov_1da4qle0dk().b[11][0]++, tabs.filter(function (tab) {
      cov_1da4qle0dk().f[7]++;
      cov_1da4qle0dk().s[25]++;
      return (cov_1da4qle0dk().b[12][0]++, !_constants.ProductTypeByProductTabEnum[tab.code]) || (cov_1da4qle0dk().b[12][1]++, _constants.ProductTypeByProductTabEnum[tab.code].some(function (prodType) {
        cov_1da4qle0dk().f[8]++;
        cov_1da4qle0dk().s[26]++;
        return ((cov_1da4qle0dk().b[13][0]++, catalogSummary.productTypes) || (cov_1da4qle0dk().b[13][1]++, [])).indexOf(prodType) >= 0;
      }));
    })) : (cov_1da4qle0dk().b[11][1]++, tabs);
  }
});
var ProductListModel = (cov_1da4qle0dk().s[27]++, {
  /**
   * Return a sectionsByTab map for ProductList
   * @param tabDatas: configuration tabs, respect ordering of passed tabs
   * @param catalogSummary: catalog summary
   * @param isSeasonHighlighted: grouped by season or not
   * @return a ProductListType which is map of ProductTabType by Tab code
   */
  getProductList: function getProductList(tabDatas, catalogSummary, isSeasonHighlighted, config) {
    cov_1da4qle0dk().f[9]++;
    // Hide filter price in report context
    var tabs = (cov_1da4qle0dk().s[28]++, ProductTabModel.get(tabDatas, catalogSummary, !config.isReportContext, config.isFilterProductTypeEnable));
    // Produce a sections by product tab map
    cov_1da4qle0dk().s[29]++;
    return tabs.map(function (tab) {
      cov_1da4qle0dk().f[10]++;
      var groupedData;
      var tabCode = (cov_1da4qle0dk().s[30]++, tab.code);
      var customSectionDisplay;
      cov_1da4qle0dk().s[31]++;
      if (isSeasonHighlighted) {
        cov_1da4qle0dk().b[14][0]++;
        cov_1da4qle0dk().s[32]++;
        groupedData = catalogSummary.seasons;
      } else {
        cov_1da4qle0dk().b[14][1]++;
        cov_1da4qle0dk().s[33]++;
        switch (tabCode) {
          case _constants.ProductTabEnum.OFFERS:
            cov_1da4qle0dk().b[15][0]++;
            cov_1da4qle0dk().s[34]++;
            groupedData = (0, _toConsumableArray2.default)(catalogSummary.advantageTypes).map(function (advType) {
              cov_1da4qle0dk().f[11]++;
              cov_1da4qle0dk().s[35]++;
              return {
                code: advType,
                name: null
              };
            });
            cov_1da4qle0dk().s[36]++;
            break;
          // section by advantage
          // Personal offer if any otherwise All offers
          // for event or sporting event
          // grouped by subtopic Id
          case _constants.ProductTabEnum.EVENTS:
            cov_1da4qle0dk().b[15][1]++;
            cov_1da4qle0dk().s[37]++;
            groupedData = (0, _toConsumableArray2.default)(catalogSummary.subTopics);
            cov_1da4qle0dk().s[38]++;
            if (catalogSummary.containsProductWithoutTopic) {
              cov_1da4qle0dk().b[16][0]++;
              cov_1da4qle0dk().s[39]++;
              groupedData.push({
                code: _section.SectionCodeEnum.ALL_EVENTS,
                name: null
              });
            } else {
              cov_1da4qle0dk().b[16][1]++;
            }
            cov_1da4qle0dk().s[40]++;
            break;
          // grouped by product family
          case _constants.ProductTabEnum.VISIT:
            cov_1da4qle0dk().b[15][2]++;
          case _constants.ProductTabEnum.GOODS:
            cov_1da4qle0dk().b[15][3]++;
          case _constants.ProductTabEnum.SEASON_TICKETS:
            cov_1da4qle0dk().b[15][4]++;
          case _constants.ProductTabEnum.OTHER_PRODUCTS:
            cov_1da4qle0dk().b[15][5]++;
          case _constants.ProductTabEnum.HOSPITALITY:
            cov_1da4qle0dk().b[15][6]++;
          case _constants.ProductTabEnum.HOSPITALITY_BUNDLE:
            cov_1da4qle0dk().b[15][7]++;
            cov_1da4qle0dk().s[41]++;
            // For others which are neither Good nor above product type (event, sporting event, visit, visit pass, season ticket)
            groupedData = catalogSummary.productTypes.filter(function (prodType) {
              cov_1da4qle0dk().f[12]++;
              cov_1da4qle0dk().s[42]++;
              return _constants.ProductTypeByProductTabEnum[tabCode].indexOf(prodType) > -1;
            }).map(function (prodType) {
              cov_1da4qle0dk().f[13]++;
              cov_1da4qle0dk().s[43]++;
              return {
                code: prodType,
                name: null
              };
            });
            cov_1da4qle0dk().s[44]++;
            break;
          case _constants.ProductTabEnum.TOURS:
            cov_1da4qle0dk().b[15][8]++;
            cov_1da4qle0dk().s[45]++;
            groupedData = [{
              code: 'TOURS',
              name: null
            }];
            // Customize the url for axios to get the tours, because tours use the separate Rest API to get the result. ( `/tours` instead of `/products` )
            // The section item is also on another path ( `.tours` instead of `.products`)
            cov_1da4qle0dk().s[46]++;
            customSectionDisplay = {
              retrievalUrlPath: 'tours',
              itemsPath: 'tours'
            };
            cov_1da4qle0dk().s[47]++;
            break;
          default:
            cov_1da4qle0dk().b[15][9]++;
            cov_1da4qle0dk().s[48]++;
            groupedData = [];
            cov_1da4qle0dk().s[49]++;
            break;
        }
      }
      cov_1da4qle0dk().s[50]++;
      return {
        code: tabCode,
        productTypes: tab.productTypes,
        arrFilters: tab.arrFilters,
        customSectionDisplay: customSectionDisplay,
        sections: groupedData.map(function (data) {
          cov_1da4qle0dk().f[14]++;
          cov_1da4qle0dk().s[51]++;
          return _objectSpread(_objectSpread({}, _section.SectionModel.getSectionForProducts(data, [], config)), {
            LOADING: true,
            ERROR: false
          });
        })
      };
    }).filter(function (tab) {
      cov_1da4qle0dk().f[15]++;
      cov_1da4qle0dk().s[52]++;
      return tab.sections.length > 0;
    }); // don't show tabs that have no section;
  },
  /**
   *
   */
  loadProductsIntoSection: function loadProductsIntoSection(tabs, tabCode, sectionCode, hasMore, loadingState, products, config, isFilterChanged, generateAllId) {
    cov_1da4qle0dk().f[16]++;
    cov_1da4qle0dk().s[53]++;
    return tabs.map(function (tab) {
      cov_1da4qle0dk().f[17]++;
      cov_1da4qle0dk().s[54]++;
      if (tab.code === tabCode) {
        cov_1da4qle0dk().b[17][0]++;
        cov_1da4qle0dk().s[55]++;
        return _objectSpread(_objectSpread({}, tab), {}, {
          sections: tab.sections.map(function (section) {
            cov_1da4qle0dk().f[18]++;
            var auxSection = (cov_1da4qle0dk().s[56]++, (0, _assign.default)({}, section));
            cov_1da4qle0dk().s[57]++;
            if (auxSection.code === sectionCode) {
              cov_1da4qle0dk().b[18][0]++;
              cov_1da4qle0dk().s[58]++;
              // If the filter has ben changed, we remove the previous items for the section
              if (isFilterChanged) {
                cov_1da4qle0dk().b[19][0]++;
                cov_1da4qle0dk().s[59]++;
                auxSection.clusters = auxSection.clusters.map(function (cluster) {
                  cov_1da4qle0dk().f[19]++;
                  cov_1da4qle0dk().s[60]++;
                  return _objectSpread(_objectSpread({}, cluster), {}, {
                    items: []
                  });
                });
              } else {
                cov_1da4qle0dk().b[19][1]++;
              }
              var newSection = (cov_1da4qle0dk().s[61]++, (cov_1da4qle0dk().b[21][0]++, !loadingState.LOADING) && (cov_1da4qle0dk().b[21][1]++, !loadingState.ERROR) ? (cov_1da4qle0dk().b[20][0]++, _section.SectionModel.loadProductsIntoSection(auxSection, products, config, generateAllId)) : (cov_1da4qle0dk().b[20][1]++, auxSection));
              cov_1da4qle0dk().s[62]++;
              return _objectSpread(_objectSpread(_objectSpread({}, newSection), loadingState), {}, {
                hasMore: hasMore
              });
            } else {
              cov_1da4qle0dk().b[18][1]++;
            }
            cov_1da4qle0dk().s[63]++;
            return auxSection;
          })
        });
      } else {
        cov_1da4qle0dk().b[17][1]++;
      }
      cov_1da4qle0dk().s[64]++;
      return tab;
    });
  },
  hasData: function hasData(productList) {
    cov_1da4qle0dk().f[20]++;
    cov_1da4qle0dk().s[65]++;
    return (cov_1da4qle0dk().b[22][0]++, (0, _isArray.default)(productList.tabs)) && (cov_1da4qle0dk().b[22][1]++, productList.tabs.length > 0);
  },
  /**
   * Update product id that change to Section > selectProductIds
   */
  updateSelectProductIds: function updateSelectProductIds(tabs, tabCode, sectionCode, changedProductId, isSelectAll) {
    cov_1da4qle0dk().f[21]++;
    cov_1da4qle0dk().s[66]++;
    return tabs.map(function (tab) {
      cov_1da4qle0dk().f[22]++;
      cov_1da4qle0dk().s[67]++;
      if (tab.code !== tabCode) {
        cov_1da4qle0dk().b[23][0]++;
        cov_1da4qle0dk().s[68]++;
        return tab;
      } else {
        cov_1da4qle0dk().b[23][1]++;
      }
      cov_1da4qle0dk().s[69]++;
      return _objectSpread(_objectSpread({}, tab), {}, {
        sections: tab.sections.map(function (section) {
          cov_1da4qle0dk().f[23]++;
          cov_1da4qle0dk().s[70]++;
          if (section.code !== sectionCode) {
            cov_1da4qle0dk().b[24][0]++;
            cov_1da4qle0dk().s[71]++;
            return section;
          } else {
            cov_1da4qle0dk().b[24][1]++;
          }
          cov_1da4qle0dk().s[72]++;
          return _section.SectionModel.updateSelectProductIds(section, changedProductId, isSelectAll);
        })
      });
    });
  },
  getRawProductsOfTab: function getRawProductsOfTab(tabs, tabCode) {
    cov_1da4qle0dk().f[24]++;
    var products = (cov_1da4qle0dk().s[73]++, []);
    cov_1da4qle0dk().s[74]++;
    tabs.forEach(function (tab) {
      cov_1da4qle0dk().f[25]++;
      cov_1da4qle0dk().s[75]++;
      if ((cov_1da4qle0dk().b[26][0]++, tabCode) && (cov_1da4qle0dk().b[26][1]++, tab.code !== tabCode)) {
        cov_1da4qle0dk().b[25][0]++;
        cov_1da4qle0dk().s[76]++;
        return;
      } else {
        cov_1da4qle0dk().b[25][1]++;
      }
      cov_1da4qle0dk().s[77]++;
      tab.sections.forEach(function (section) {
        cov_1da4qle0dk().f[26]++;
        var sectionProducts = (cov_1da4qle0dk().s[78]++, _section.SectionModel.getRawProducts(section));
        cov_1da4qle0dk().s[79]++;
        sectionProducts.forEach(function (product) {
          cov_1da4qle0dk().f[27]++;
          cov_1da4qle0dk().s[80]++;
          return products.push(product);
        });
      });
    });
    cov_1da4qle0dk().s[81]++;
    return products;
  },
  /**
   * Return a array of select products of 1 tab or all tab (if not pass tab code)
   */
  getSelectProductsOfTab: function getSelectProductsOfTab(tabs, tabCode) {
    cov_1da4qle0dk().f[28]++;
    cov_1da4qle0dk().s[82]++;
    return (0, _flatten.default)(tabs.filter(function (tab) {
      cov_1da4qle0dk().f[29]++;
      cov_1da4qle0dk().s[83]++;
      return (cov_1da4qle0dk().b[27][0]++, !tabCode) || (cov_1da4qle0dk().b[27][1]++, tab.code === tabCode);
    }).map(function (tab) {
      cov_1da4qle0dk().f[30]++;
      cov_1da4qle0dk().s[84]++;
      return _section.SectionModel.getSelectProducts(tab.sections);
    }));
  },
  loadPositionOfProduct: function loadPositionOfProduct(analyticData, tabs, tabCode, sectionCode, config) {
    cov_1da4qle0dk().f[31]++;
    var _ref = (cov_1da4qle0dk().s[85]++, config),
      language = _ref.language,
      defaultLanguage = _ref.defaultLanguage;
    var currentTab = (cov_1da4qle0dk().s[86]++, tabs.find(function (tab) {
      cov_1da4qle0dk().f[32]++;
      cov_1da4qle0dk().s[87]++;
      return tab.code === tabCode;
    }));
    var newAnalyticData = (cov_1da4qle0dk().s[88]++, {
      products: (0, _toConsumableArray2.default)(analyticData.products),
      promotions: (0, _toConsumableArray2.default)(analyticData.promotions)
    });
    cov_1da4qle0dk().s[89]++;
    if (!currentTab) {
      cov_1da4qle0dk().b[28][0]++;
      cov_1da4qle0dk().s[90]++;
      return null;
    } else {
      cov_1da4qle0dk().b[28][1]++;
    }
    var currentSection = (cov_1da4qle0dk().s[91]++, (cov_1da4qle0dk().b[29][0]++, currentTab.sections) && (cov_1da4qle0dk().b[29][1]++, currentTab.sections.find(function (section) {
      cov_1da4qle0dk().f[33]++;
      cov_1da4qle0dk().s[92]++;
      return section.code === sectionCode;
    })));
    cov_1da4qle0dk().s[93]++;
    if (!currentSection) {
      cov_1da4qle0dk().b[30][0]++;
      cov_1da4qle0dk().s[94]++;
      return null;
    } else {
      cov_1da4qle0dk().b[30][1]++;
    }
    cov_1da4qle0dk().s[95]++;
    if ((0, _size.default)(currentSection.clusters) === 0) {
      cov_1da4qle0dk().b[31][0]++;
      cov_1da4qle0dk().s[96]++;
      return null;
    } else {
      cov_1da4qle0dk().b[31][1]++;
    }
    var currentSectionCode = (cov_1da4qle0dk().s[97]++, currentSection.code);
    var currentTabCode = (cov_1da4qle0dk().s[98]++, tabCode);
    cov_1da4qle0dk().s[99]++;
    currentSection.clusters.forEach(function (cluster) {
      cov_1da4qle0dk().f[34]++;
      var _ref2 = (cov_1da4qle0dk().s[100]++, cluster),
        items = _ref2.items;
      cov_1da4qle0dk().s[101]++;
      if ((0, _size.default)(items) === 0) {
        cov_1da4qle0dk().b[32][0]++;
        cov_1da4qle0dk().s[102]++;
        return null;
      } else {
        cov_1da4qle0dk().b[32][1]++;
      }
      var position = (cov_1da4qle0dk().s[103]++, 0);
      cov_1da4qle0dk().s[104]++;
      items.forEach(function (item) {
        cov_1da4qle0dk().f[35]++;
        var brand;
        var list;
        var currentAdvantages = (cov_1da4qle0dk().s[105]++, []);
        var _ref3 = (cov_1da4qle0dk().s[106]++, item),
          product = _ref3.product;
        var _ref4 = (cov_1da4qle0dk().s[107]++, product),
          advantages = _ref4.advantages;
        var _ref5 = (cov_1da4qle0dk().s[108]++, newAnalyticData),
          productAnalyticData = _ref5.products,
          promotionAnalyticData = _ref5.promotions;
        var advantageDefaultPosition = (cov_1da4qle0dk().s[109]++, 0);
        cov_1da4qle0dk().s[110]++;
        if ((0, _size.default)(advantages) > 0) {
          cov_1da4qle0dk().b[33][0]++;
          cov_1da4qle0dk().s[111]++;
          advantages.forEach(function (advantage) {
            cov_1da4qle0dk().f[36]++;
            var promotionAnalyticDatum = (cov_1da4qle0dk().s[112]++, {
              id: (cov_1da4qle0dk().b[34][0]++, advantage.id) && (cov_1da4qle0dk().b[34][1]++, advantage.id.toString()),
              name: advantage.name,
              creative: (cov_1da4qle0dk().b[35][0]++, advantage.description) || (cov_1da4qle0dk().b[35][1]++, ""),
              // Advantages position may not in consecutive order, therefore set its position equal to 0 here and calculate later
              position: advantageDefaultPosition,
              // Tab code doesn't need to push to datalayer but we need this field to handle already pushed product, but in different tab.
              tabCode: currentTabCode
            });
            cov_1da4qle0dk().s[113]++;
            currentAdvantages.push(promotionAnalyticDatum);
            cov_1da4qle0dk().s[114]++;
            promotionAnalyticData.push(promotionAnalyticDatum);
          });
        } else {
          cov_1da4qle0dk().b[33][1]++;
        }
        cov_1da4qle0dk().s[115]++;
        switch (product.productType) {
          case _product.ProductTypeEnum.HOSPITALITY:
            cov_1da4qle0dk().b[36][0]++;
            cov_1da4qle0dk().s[116]++;
            currentSectionCode = (0, _get.default)(product, "sessions[0].id", null);
            cov_1da4qle0dk().s[117]++;
            currentTabCode = (0, _get.default)(product, "sessions[0].id", null);
            cov_1da4qle0dk().s[118]++;
            position = 0;
            cov_1da4qle0dk().s[119]++;
            break;
          case _product.ProductTypeEnum.HOSPITALITY_BUNDLE:
            cov_1da4qle0dk().b[36][1]++;
            cov_1da4qle0dk().s[120]++;
            currentTabCode = (0, _get.default)(product, "code", null);
            cov_1da4qle0dk().s[121]++;
            currentSectionCode = (0, _get.default)(product, "code", null);
            // Hospitality products has filter so we will set its positions after filtered.
            cov_1da4qle0dk().s[122]++;
            position = 0;
            cov_1da4qle0dk().s[123]++;
            break;
          default:
            cov_1da4qle0dk().b[36][2]++;
            cov_1da4qle0dk().s[124]++;
            break;
        }
        var isProductAdded = (cov_1da4qle0dk().s[125]++, productAnalyticData.find(function (datum) {
          cov_1da4qle0dk().f[37]++;
          cov_1da4qle0dk().s[126]++;
          return (cov_1da4qle0dk().b[37][0]++, datum.id === product.id) && (cov_1da4qle0dk().b[37][1]++, datum.sectionCode === currentSectionCode) && (cov_1da4qle0dk().b[37][2]++, datum.tabCode === currentTabCode);
        }));
        cov_1da4qle0dk().s[127]++;
        if (isProductAdded) {
          cov_1da4qle0dk().b[38][0]++;
          cov_1da4qle0dk().s[128]++;
          position += 1;
          cov_1da4qle0dk().s[129]++;
          return null;
        } else {
          cov_1da4qle0dk().b[38][1]++;
        }
        cov_1da4qle0dk().s[130]++;
        if (!product.productType) {
          cov_1da4qle0dk().b[39][0]++;
          cov_1da4qle0dk().s[131]++;
          brand = currentTabCode;
          cov_1da4qle0dk().s[132]++;
          list = currentTabCode;
        } else {
          cov_1da4qle0dk().b[39][1]++;
          cov_1da4qle0dk().s[133]++;
          brand = (0, _helper.getTranslation)(product.productFamilyName, language, defaultLanguage);
          cov_1da4qle0dk().s[134]++;
          list = product.productType;
        }
        var productType = (cov_1da4qle0dk().s[135]++, _product.ProductModel.getProductType(product));
        var currentProduct = (cov_1da4qle0dk().s[136]++, {
          id: (cov_1da4qle0dk().b[40][0]++, product.id) && (cov_1da4qle0dk().b[40][1]++, product.id.toString()),
          name: product.name,
          brand: (cov_1da4qle0dk().b[41][0]++, brand) || (cov_1da4qle0dk().b[41][1]++, ""),
          type: productType,
          position: position,
          list: (cov_1da4qle0dk().b[42][0]++, list) || (cov_1da4qle0dk().b[42][1]++, ""),
          // Tab code and section doesn't need to push to datalayer but we need this field to handle already pushed product, but in different tab.
          tabCode: currentTabCode,
          sectionCode: currentSectionCode
        });
        cov_1da4qle0dk().s[137]++;
        productAnalyticData.push(currentProduct);
        cov_1da4qle0dk().s[138]++;
        position += 1;
        cov_1da4qle0dk().s[139]++;
        product.productDataLayer = currentProduct;
        cov_1da4qle0dk().s[140]++;
        product.advantageDataLayer = [].concat(currentAdvantages);
        cov_1da4qle0dk().s[141]++;
        return null;
      });
      cov_1da4qle0dk().s[142]++;
      return null;
    });
    cov_1da4qle0dk().s[143]++;
    return newAnalyticData;
  },
  changeLanguage: function changeLanguage(language, defaultLanguage, tabs) {
    cov_1da4qle0dk().f[38]++;
    cov_1da4qle0dk().s[144]++;
    return tabs.map(function (tab) {
      cov_1da4qle0dk().f[39]++;
      cov_1da4qle0dk().s[145]++;
      return _objectSpread(_objectSpread({}, tab), _catalog.CatalogModel.changeLanguage(language, defaultLanguage, tab.sections));
    });
  }
});
var _default = exports.default = ProductListModel;